import React from "react";
import PageTemplate from "../../../templates/page-template";

export default function StartAChapterPage() {
	return <PageTemplate header="Start A Chapter" />;
}
